<template>
  <v-fade-transition>
    <div v-if="loading" class="pw-loader">
      <v-progress-linear
        indeterminate
        color="primary"
        height="3"
        rounded
      ></v-progress-linear>
      <div v-if="label" class="pw-loader__label">{{ label }}</div>
    </div>
  </v-fade-transition>
</template>

<script>
/**
 * Thin indeterminate bar shown while a page is fetching its data.
 * Registered globally in main.js, so it can be dropped into any view
 * as <page-loader :loading="isLoading" />.
 */
export default {
  name: "PageLoader",
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: "",
    },
  },
};
</script>

<style scoped>
.pw-loader {
  width: 100%;
}

.pw-loader__label {
  font-size: 0.75rem;
  color: #66738a;
  padding: 8px 0 0;
}
</style>
